/** bagimliliklar[x] = x'in formülünde geçen parametre adları. */
export class FikoBagimlilikGrafi {
  private ileri = new Map<string, Set<string>>();   // dep -> dependents (dep değişince bunlar etkilenir)
  private dugumler: string[];
  constructor(bagimliliklar: Record<string, string[]>) {
    this.dugumler = Object.keys(bagimliliklar);
    for (const ad of this.dugumler) this.ileri.set(ad, new Set());
    for (const [ad, deps] of Object.entries(bagimliliklar))
      for (const d of deps) { if (!this.ileri.has(d)) this.ileri.set(d, new Set()); this.ileri.get(d)!.add(ad); }
  }
  topolojikSira(): string[] {
    const derece = new Map<string, number>(); const tumu = new Set([...this.ileri.keys()]);
    for (const a of tumu) derece.set(a, 0);
    for (const [, deps] of this.ileri) for (const t of deps) derece.set(t, (derece.get(t) || 0) + 1);
    const kuyruk = [...tumu].filter(a => (derece.get(a) || 0) === 0).sort();
    const sira: string[] = [];
    while (kuyruk.length) {
      const a = kuyruk.shift()!; sira.push(a);
      for (const t of (this.ileri.get(a) || [])) { derece.set(t, derece.get(t)! - 1); if (derece.get(t) === 0) kuyruk.push(t); }
    }
    return sira;
  }
  downstream(degisen: string[]): string[] {
    const sonuc = new Set<string>(); const yigin = [...degisen];
    while (yigin.length) { const a = yigin.pop()!; for (const t of (this.ileri.get(a) || [])) if (!sonuc.has(t)) { sonuc.add(t); yigin.push(t); } }
    return [...sonuc];
  }
  donguVarMi(): boolean {
    const toplam = new Set([...this.ileri.keys()]).size;
    return this.topolojikSira().length < toplam;
  }
}
